import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {GlobalState} from './types'

const initialState: GlobalState = {
  kid: undefined,
  actifQrCodeCamera: false,
}

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    resetGlobal: (state: GlobalState) => {
      state.kid = undefined
    },
    kidChanged: (state: GlobalState, action: PayloadAction<any>) => {
      state.kid = action.payload
    },
    activateQrCodeCamera: (state: GlobalState, action: PayloadAction<any>) => {
      state.actifQrCodeCamera = true
    },
    desactivateQrCodeCamera: (state: GlobalState, action: PayloadAction<any>) => {
      state.actifQrCodeCamera = false
    },
  },
})

export const {actions} = globalSlice
export default globalSlice.reducer
